<script>
import { useAlert } from 'dashboard/composables';
import { mapGetters } from 'vuex';
import NextDialog from 'dashboard/components-next/dialog/Dialog.vue';
import WebhookForm from './WebhookForm.vue';

export default {
  components: { NextDialog, WebhookForm },
  props: {
    value: {
      type: Object,
      required: true,
    },
    id: {
      type: [Number, String],
      required: true,
    },
    onClose: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters({ uiFlags: 'webhooks/getUIFlags' }),
  },
  mounted() {
    this.$refs.dialogRef?.open();
  },
  methods: {
    async onSubmit(webhook) {
      try {
        await this.$store.dispatch('webhooks/update', {
          webhook,
          id: this.id,
        });
        useAlert(
          this.$t('INTEGRATION_SETTINGS.WEBHOOK.EDIT.API.SUCCESS_MESSAGE')
        );
        this.onClose();
      } catch (error) {
        const alertMessage =
          error?.response?.data?.message ||
          this.$t('INTEGRATION_SETTINGS.WEBHOOK.EDIT.API.ERROR_MESSAGE');
        useAlert(alertMessage);
      }
    },
  },
};
</script>

<template>
  <NextDialog
    ref="dialogRef"
    width="xl"
    overflow-y-auto
    :title="$t('INTEGRATION_SETTINGS.WEBHOOK.EDIT.TITLE')"
    :show-cancel-button="false"
    :show-confirm-button="false"
    @close="onClose"
  >
    <WebhookForm
      :value="value"
      :is-submitting="uiFlags.updatingItem"
      :submit-label="$t('INTEGRATION_SETTINGS.WEBHOOK.FORM.EDIT_SUBMIT')"
      @submit="onSubmit"
      @cancel="onClose"
    />
    <template #footer />
  </NextDialog>
</template>
